var map = {
	"./Advertisements": [
		1216,
		3532,
		2045,
		7150,
		2441,
		1216
	],
	"./Advertisements/": [
		1216,
		3532,
		2045,
		7150,
		2441,
		1216
	],
	"./Advertisements/Columns": [
		9589,
		9589
	],
	"./Advertisements/Columns.tsx": [
		9589,
		9589
	],
	"./Advertisements/Form": [
		1717,
		3532,
		2045,
		7150,
		2441,
		1717
	],
	"./Advertisements/Form/": [
		1717,
		3532,
		2045,
		7150,
		2441,
		1717
	],
	"./Advertisements/Form/index": [
		1717,
		3532,
		2045,
		7150,
		2441,
		1717
	],
	"./Advertisements/Form/index.tsx": [
		1717,
		3532,
		2045,
		7150,
		2441,
		1717
	],
	"./Advertisements/View": [
		7928,
		7928
	],
	"./Advertisements/View/": [
		7928,
		7928
	],
	"./Advertisements/View/index": [
		7928,
		7928
	],
	"./Advertisements/View/index.tsx": [
		7928,
		7928
	],
	"./Advertisements/index": [
		1216,
		3532,
		2045,
		7150,
		2441,
		1216
	],
	"./Advertisements/index.tsx": [
		1216,
		3532,
		2045,
		7150,
		2441,
		1216
	],
	"./Categories": [
		3978,
		3532,
		2045,
		7150,
		2441,
		3978
	],
	"./Categories/": [
		3978,
		3532,
		2045,
		7150,
		2441,
		3978
	],
	"./Categories/Columns": [
		2395,
		3532,
		2045,
		2441,
		2395
	],
	"./Categories/Columns.tsx": [
		2395,
		3532,
		2045,
		2441,
		2395
	],
	"./Categories/Create": [
		6738,
		3532,
		2045,
		7150,
		2441,
		4357
	],
	"./Categories/Create/": [
		6738,
		3532,
		2045,
		7150,
		2441,
		4357
	],
	"./Categories/Create/index": [
		6738,
		3532,
		2045,
		7150,
		2441,
		4357
	],
	"./Categories/Create/index.tsx": [
		6738,
		3532,
		2045,
		7150,
		2441,
		4357
	],
	"./Categories/Form": [
		5995,
		3532,
		2045,
		7150,
		2441,
		5995
	],
	"./Categories/Form/": [
		5995,
		3532,
		2045,
		7150,
		2441,
		5995
	],
	"./Categories/Form/index": [
		5995,
		3532,
		2045,
		7150,
		2441,
		5995
	],
	"./Categories/Form/index.tsx": [
		5995,
		3532,
		2045,
		7150,
		2441,
		5995
	],
	"./Categories/SubCategory": [
		3126,
		3532,
		2045,
		2441,
		745
	],
	"./Categories/SubCategory/": [
		3126,
		3532,
		2045,
		2441,
		745
	],
	"./Categories/SubCategory/Form": [
		7694,
		3532,
		2045,
		7150,
		2441,
		7694
	],
	"./Categories/SubCategory/Form/": [
		7694,
		3532,
		2045,
		7150,
		2441,
		7694
	],
	"./Categories/SubCategory/Form/index": [
		7694,
		3532,
		2045,
		7150,
		2441,
		7694
	],
	"./Categories/SubCategory/Form/index.tsx": [
		7694,
		3532,
		2045,
		7150,
		2441,
		7694
	],
	"./Categories/SubCategory/SubColumns": [
		6946,
		3532,
		2045,
		2441,
		6946
	],
	"./Categories/SubCategory/SubColumns.tsx": [
		6946,
		3532,
		2045,
		2441,
		6946
	],
	"./Categories/SubCategory/index": [
		3126,
		3532,
		2045,
		2441,
		745
	],
	"./Categories/SubCategory/index.tsx": [
		3126,
		3532,
		2045,
		2441,
		745
	],
	"./Categories/index": [
		3978,
		3532,
		2045,
		7150,
		2441,
		3978
	],
	"./Categories/index.tsx": [
		3978,
		3532,
		2045,
		7150,
		2441,
		3978
	],
	"./Coupons": [
		9110,
		3532,
		2045,
		7150,
		2441,
		9110
	],
	"./Coupons/": [
		9110,
		3532,
		2045,
		7150,
		2441,
		9110
	],
	"./Coupons/Assign": [
		9393,
		3532,
		2045,
		7150,
		2441,
		9393
	],
	"./Coupons/Assign/": [
		9393,
		3532,
		2045,
		7150,
		2441,
		9393
	],
	"./Coupons/Assign/index": [
		9393,
		3532,
		2045,
		7150,
		2441,
		9393
	],
	"./Coupons/Assign/index.tsx": [
		9393,
		3532,
		2045,
		7150,
		2441,
		9393
	],
	"./Coupons/Columns": [
		8290,
		8290
	],
	"./Coupons/Columns.tsx": [
		8290,
		8290
	],
	"./Coupons/Form": [
		3420,
		3532,
		2045,
		7150,
		2441,
		3420
	],
	"./Coupons/Form/": [
		3420,
		3532,
		2045,
		7150,
		2441,
		3420
	],
	"./Coupons/Form/index": [
		3420,
		3532,
		2045,
		7150,
		2441,
		3420
	],
	"./Coupons/Form/index.tsx": [
		3420,
		3532,
		2045,
		7150,
		2441,
		3420
	],
	"./Coupons/index": [
		9110,
		3532,
		2045,
		7150,
		2441,
		9110
	],
	"./Coupons/index.tsx": [
		9110,
		3532,
		2045,
		7150,
		2441,
		9110
	],
	"./Customers": [
		2621,
		3532,
		2045,
		8877,
		2441,
		2621
	],
	"./Customers/": [
		2621,
		3532,
		2045,
		8877,
		2441,
		2621
	],
	"./Customers/Column": [
		6163,
		6163
	],
	"./Customers/Column.tsx": [
		6163,
		6163
	],
	"./Customers/index": [
		2621,
		3532,
		2045,
		8877,
		2441,
		2621
	],
	"./Customers/index.tsx": [
		2621,
		3532,
		2045,
		8877,
		2441,
		2621
	],
	"./Dashboard": [
		933,
		3532,
		2045,
		7150,
		8537,
		2441,
		5701
	],
	"./Dashboard/": [
		933,
		3532,
		2045,
		7150,
		8537,
		2441,
		5701
	],
	"./Dashboard/CancelForm": [
		9209,
		3532,
		2045,
		7150,
		2441,
		9209
	],
	"./Dashboard/CancelForm/": [
		9209,
		3532,
		2045,
		7150,
		2441,
		9209
	],
	"./Dashboard/CancelForm/index": [
		9209,
		3532,
		2045,
		7150,
		2441,
		9209
	],
	"./Dashboard/CancelForm/index.tsx": [
		9209,
		3532,
		2045,
		7150,
		2441,
		9209
	],
	"./Dashboard/ReceiptForm": [
		2569,
		3532,
		2045,
		2441,
		2569
	],
	"./Dashboard/ReceiptForm/": [
		2569,
		3532,
		2045,
		2441,
		2569
	],
	"./Dashboard/ReceiptForm/index": [
		2569,
		3532,
		2045,
		2441,
		2569
	],
	"./Dashboard/ReceiptForm/index.tsx": [
		2569,
		3532,
		2045,
		2441,
		2569
	],
	"./Dashboard/index": [
		933,
		3532,
		2045,
		7150,
		8537,
		2441,
		5701
	],
	"./Dashboard/index.tsx": [
		933,
		3532,
		2045,
		7150,
		8537,
		2441,
		5701
	],
	"./DefaultSettings": [
		3891,
		3532,
		2045,
		7150,
		2441,
		3891
	],
	"./DefaultSettings/": [
		3891,
		3532,
		2045,
		7150,
		2441,
		3891
	],
	"./DefaultSettings/index": [
		3891,
		3532,
		2045,
		7150,
		2441,
		3891
	],
	"./DefaultSettings/index.tsx": [
		3891,
		3532,
		2045,
		7150,
		2441,
		3891
	],
	"./Delivery": [
		4990,
		3532,
		2045,
		2441,
		4990
	],
	"./Delivery/": [
		4990,
		3532,
		2045,
		2441,
		4990
	],
	"./Delivery/Card": [
		1759,
		3532,
		2045,
		2441,
		1759
	],
	"./Delivery/Card/": [
		1759,
		3532,
		2045,
		2441,
		1759
	],
	"./Delivery/Card/index": [
		1759,
		3532,
		2045,
		2441,
		1759
	],
	"./Delivery/Card/index.tsx": [
		1759,
		3532,
		2045,
		2441,
		1759
	],
	"./Delivery/index": [
		4990,
		3532,
		2045,
		2441,
		4990
	],
	"./Delivery/index.tsx": [
		4990,
		3532,
		2045,
		2441,
		4990
	],
	"./Inquiries": [
		1545,
		3532,
		2045,
		8877,
		2441,
		1545
	],
	"./Inquiries/": [
		1545,
		3532,
		2045,
		8877,
		2441,
		1545
	],
	"./Inquiries/Column": [
		1575,
		1575
	],
	"./Inquiries/Column.tsx": [
		1575,
		1575
	],
	"./Inquiries/View": [
		6671,
		6671
	],
	"./Inquiries/View/": [
		6671,
		6671
	],
	"./Inquiries/View/index": [
		6671,
		6671
	],
	"./Inquiries/View/index.tsx": [
		6671,
		6671
	],
	"./Inquiries/index": [
		1545,
		3532,
		2045,
		8877,
		2441,
		1545
	],
	"./Inquiries/index.tsx": [
		1545,
		3532,
		2045,
		8877,
		2441,
		1545
	],
	"./LandingImages": [
		1045,
		3532,
		2045,
		7150,
		2441,
		1045
	],
	"./LandingImages/": [
		1045,
		3532,
		2045,
		7150,
		2441,
		1045
	],
	"./LandingImages/Columns": [
		9384,
		9384
	],
	"./LandingImages/Columns.tsx": [
		9384,
		9384
	],
	"./LandingImages/Form": [
		7522,
		3532,
		2045,
		7150,
		2441,
		7522
	],
	"./LandingImages/Form/": [
		7522,
		3532,
		2045,
		7150,
		2441,
		7522
	],
	"./LandingImages/Form/index": [
		7522,
		3532,
		2045,
		7150,
		2441,
		7522
	],
	"./LandingImages/Form/index.tsx": [
		7522,
		3532,
		2045,
		7150,
		2441,
		7522
	],
	"./LandingImages/index": [
		1045,
		3532,
		2045,
		7150,
		2441,
		1045
	],
	"./LandingImages/index.tsx": [
		1045,
		3532,
		2045,
		7150,
		2441,
		1045
	],
	"./Login": [
		7232,
		3532,
		2045,
		7150,
		2441,
		3912
	],
	"./Login/": [
		7232,
		3532,
		2045,
		7150,
		2441,
		3912
	],
	"./Login/index": [
		7232,
		3532,
		2045,
		7150,
		2441,
		3912
	],
	"./Login/index.tsx": [
		7232,
		3532,
		2045,
		7150,
		2441,
		3912
	],
	"./Offers": [
		1663,
		3532,
		2045,
		7150,
		2441,
		1663
	],
	"./Offers/": [
		1663,
		3532,
		2045,
		7150,
		2441,
		1663
	],
	"./Offers/Columns": [
		2862,
		2862
	],
	"./Offers/Columns.tsx": [
		2862,
		2862
	],
	"./Offers/Form": [
		6736,
		3532,
		2045,
		7150,
		2441,
		6736
	],
	"./Offers/Form/": [
		6736,
		3532,
		2045,
		7150,
		2441,
		6736
	],
	"./Offers/Form/index": [
		6736,
		3532,
		2045,
		7150,
		2441,
		6736
	],
	"./Offers/Form/index.tsx": [
		6736,
		3532,
		2045,
		7150,
		2441,
		6736
	],
	"./Offers/index": [
		1663,
		3532,
		2045,
		7150,
		2441,
		1663
	],
	"./Offers/index.tsx": [
		1663,
		3532,
		2045,
		7150,
		2441,
		1663
	],
	"./Orders": [
		5853,
		3532,
		2045,
		6833,
		2441,
		5853
	],
	"./Orders/": [
		5853,
		3532,
		2045,
		6833,
		2441,
		5853
	],
	"./Orders/Column": [
		931,
		931
	],
	"./Orders/Column.tsx": [
		931,
		931
	],
	"./Orders/ReceiptForm": [
		2946,
		3532,
		2045,
		2441,
		2946
	],
	"./Orders/ReceiptForm/": [
		2946,
		3532,
		2045,
		2441,
		2946
	],
	"./Orders/ReceiptForm/index": [
		2946,
		3532,
		2045,
		2441,
		2946
	],
	"./Orders/ReceiptForm/index.tsx": [
		2946,
		3532,
		2045,
		2441,
		2946
	],
	"./Orders/View": [
		9499,
		3532,
		2045,
		7150,
		6833,
		2441,
		9499
	],
	"./Orders/View/": [
		9499,
		3532,
		2045,
		7150,
		6833,
		2441,
		9499
	],
	"./Orders/View/index": [
		9499,
		3532,
		2045,
		7150,
		6833,
		2441,
		9499
	],
	"./Orders/View/index.tsx": [
		9499,
		3532,
		2045,
		7150,
		6833,
		2441,
		9499
	],
	"./Orders/index": [
		5853,
		3532,
		2045,
		6833,
		2441,
		5853
	],
	"./Orders/index.tsx": [
		5853,
		3532,
		2045,
		6833,
		2441,
		5853
	],
	"./Products": [
		3010,
		3532,
		2045,
		2441,
		3010
	],
	"./Products/": [
		3010,
		3532,
		2045,
		2441,
		3010
	],
	"./Products/Columns": [
		5027,
		5027
	],
	"./Products/Columns.tsx": [
		5027,
		5027
	],
	"./Products/Create": [
		9085,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		9085
	],
	"./Products/Create/": [
		9085,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		9085
	],
	"./Products/Create/index": [
		9085,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		9085
	],
	"./Products/Create/index.tsx": [
		9085,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		9085
	],
	"./Products/Edit": [
		8089,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		8089
	],
	"./Products/Edit/": [
		8089,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		8089
	],
	"./Products/Edit/index": [
		8089,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		8089
	],
	"./Products/Edit/index.tsx": [
		8089,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691,
		8089
	],
	"./Products/Form": [
		6691,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691
	],
	"./Products/Form/": [
		6691,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691
	],
	"./Products/Form/AddonForm": [
		3474,
		3532,
		2045,
		2441,
		3474
	],
	"./Products/Form/AddonForm/": [
		3474,
		3532,
		2045,
		2441,
		3474
	],
	"./Products/Form/AddonForm/index": [
		3474,
		3532,
		2045,
		2441,
		3474
	],
	"./Products/Form/AddonForm/index.tsx": [
		3474,
		3532,
		2045,
		2441,
		3474
	],
	"./Products/Form/OptionForm": [
		1799,
		3532,
		2045,
		2441,
		1799
	],
	"./Products/Form/OptionForm/": [
		1799,
		3532,
		2045,
		2441,
		1799
	],
	"./Products/Form/OptionForm/index": [
		1799,
		3532,
		2045,
		2441,
		1799
	],
	"./Products/Form/OptionForm/index.tsx": [
		1799,
		3532,
		2045,
		2441,
		1799
	],
	"./Products/Form/OptionalItemCard": [
		2085,
		3532,
		2045,
		1981,
		2441,
		2085
	],
	"./Products/Form/OptionalItemCard/": [
		2085,
		3532,
		2045,
		1981,
		2441,
		2085
	],
	"./Products/Form/OptionalItemCard/index": [
		2085,
		3532,
		2045,
		1981,
		2441,
		2085
	],
	"./Products/Form/OptionalItemCard/index.tsx": [
		2085,
		3532,
		2045,
		1981,
		2441,
		2085
	],
	"./Products/Form/VarientForm": [
		8451,
		3532,
		2045,
		1981,
		2441,
		8451
	],
	"./Products/Form/VarientForm/": [
		8451,
		3532,
		2045,
		1981,
		2441,
		8451
	],
	"./Products/Form/VarientForm/index": [
		8451,
		3532,
		2045,
		1981,
		2441,
		8451
	],
	"./Products/Form/VarientForm/index.tsx": [
		8451,
		3532,
		2045,
		1981,
		2441,
		8451
	],
	"./Products/Form/index": [
		6691,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691
	],
	"./Products/Form/index.tsx": [
		6691,
		3532,
		2045,
		7150,
		1981,
		2441,
		6691
	],
	"./Products/View": [
		7914,
		3532,
		2045,
		7150,
		6833,
		2441,
		7914
	],
	"./Products/View/": [
		7914,
		3532,
		2045,
		7150,
		6833,
		2441,
		7914
	],
	"./Products/View/AssignOffer": [
		1680,
		3532,
		2045,
		7150,
		2441,
		1680
	],
	"./Products/View/AssignOffer/": [
		1680,
		3532,
		2045,
		7150,
		2441,
		1680
	],
	"./Products/View/AssignOffer/index": [
		1680,
		3532,
		2045,
		7150,
		2441,
		1680
	],
	"./Products/View/AssignOffer/index.tsx": [
		1680,
		3532,
		2045,
		7150,
		2441,
		1680
	],
	"./Products/View/index": [
		7914,
		3532,
		2045,
		7150,
		6833,
		2441,
		7914
	],
	"./Products/View/index.tsx": [
		7914,
		3532,
		2045,
		7150,
		6833,
		2441,
		7914
	],
	"./Products/index": [
		3010,
		3532,
		2045,
		2441,
		3010
	],
	"./Products/index.tsx": [
		3010,
		3532,
		2045,
		2441,
		3010
	],
	"./Profile": [
		4217,
		3532,
		2045,
		7150,
		2441,
		5850
	],
	"./Profile/": [
		4217,
		3532,
		2045,
		7150,
		2441,
		5850
	],
	"./Profile/index": [
		4217,
		3532,
		2045,
		7150,
		2441,
		5850
	],
	"./Profile/index.tsx": [
		4217,
		3532,
		2045,
		7150,
		2441,
		5850
	],
	"./Reviews": [
		8745,
		3532,
		2045,
		7150,
		2441,
		8745
	],
	"./Reviews/": [
		8745,
		3532,
		2045,
		7150,
		2441,
		8745
	],
	"./Reviews/Column": [
		7959,
		3532,
		2045,
		2441,
		7959
	],
	"./Reviews/Column.tsx": [
		7959,
		3532,
		2045,
		2441,
		7959
	],
	"./Reviews/Form": [
		5566,
		3532,
		2045,
		7150,
		2441,
		5566
	],
	"./Reviews/Form/": [
		5566,
		3532,
		2045,
		7150,
		2441,
		5566
	],
	"./Reviews/Form/index": [
		5566,
		3532,
		2045,
		7150,
		2441,
		5566
	],
	"./Reviews/Form/index.tsx": [
		5566,
		3532,
		2045,
		7150,
		2441,
		5566
	],
	"./Reviews/View": [
		6799,
		6799
	],
	"./Reviews/View/": [
		6799,
		6799
	],
	"./Reviews/View/index": [
		6799,
		6799
	],
	"./Reviews/View/index.tsx": [
		6799,
		6799
	],
	"./Reviews/index": [
		8745,
		3532,
		2045,
		7150,
		2441,
		8745
	],
	"./Reviews/index.tsx": [
		8745,
		3532,
		2045,
		7150,
		2441,
		8745
	],
	"./Roles": [
		2388,
		3532,
		2045,
		7150,
		3536,
		2441,
		2388
	],
	"./Roles/": [
		2388,
		3532,
		2045,
		7150,
		3536,
		2441,
		2388
	],
	"./Roles/Column": [
		7240,
		7240
	],
	"./Roles/Column.tsx": [
		7240,
		7240
	],
	"./Roles/index": [
		2388,
		3532,
		2045,
		7150,
		3536,
		2441,
		2388
	],
	"./Roles/index.tsx": [
		2388,
		3532,
		2045,
		7150,
		3536,
		2441,
		2388
	],
	"./Roles/permission": [
		2287,
		3532,
		3536,
		2287
	],
	"./Roles/permission.tsx": [
		2287,
		3532,
		3536,
		2287
	],
	"./Subscriptions": [
		9112,
		3532,
		2045,
		2441,
		9112
	],
	"./Subscriptions/": [
		9112,
		3532,
		2045,
		2441,
		9112
	],
	"./Subscriptions/index": [
		9112,
		3532,
		2045,
		2441,
		9112
	],
	"./Subscriptions/index.tsx": [
		9112,
		3532,
		2045,
		2441,
		9112
	],
	"./UnAuthorized": [
		2488,
		2488
	],
	"./UnAuthorized/": [
		2488,
		2488
	],
	"./UnAuthorized/index": [
		2488,
		2488
	],
	"./UnAuthorized/index.tsx": [
		2488,
		2488
	],
	"./Users": [
		2790,
		3532,
		2045,
		7150,
		3536,
		7041,
		2441,
		2790
	],
	"./Users/": [
		2790,
		3532,
		2045,
		7150,
		3536,
		7041,
		2441,
		2790
	],
	"./Users/AssignRoleForm": [
		6396,
		3532,
		2045,
		7150,
		3536,
		2441,
		6396
	],
	"./Users/AssignRoleForm/": [
		6396,
		3532,
		2045,
		7150,
		3536,
		2441,
		6396
	],
	"./Users/AssignRoleForm/index": [
		6396,
		3532,
		2045,
		7150,
		3536,
		2441,
		6396
	],
	"./Users/AssignRoleForm/index.tsx": [
		6396,
		3532,
		2045,
		7150,
		3536,
		2441,
		6396
	],
	"./Users/Column": [
		9586,
		3532,
		2045,
		7150,
		3536,
		2441,
		9586
	],
	"./Users/Column.tsx": [
		9586,
		3532,
		2045,
		7150,
		3536,
		2441,
		9586
	],
	"./Users/Form": [
		1023,
		3532,
		2045,
		7150,
		2441,
		1023
	],
	"./Users/Form/": [
		1023,
		3532,
		2045,
		7150,
		2441,
		1023
	],
	"./Users/Form/index": [
		1023,
		3532,
		2045,
		7150,
		2441,
		1023
	],
	"./Users/Form/index.tsx": [
		1023,
		3532,
		2045,
		7150,
		2441,
		1023
	],
	"./Users/index": [
		2790,
		3532,
		2045,
		7150,
		3536,
		7041,
		2441,
		2790
	],
	"./Users/index.tsx": [
		2790,
		3532,
		2045,
		7150,
		3536,
		7041,
		2441,
		2790
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;